import React from 'react'
import { Grid, Button } from '@material-ui/core/'
import moment from 'moment'
import filterIcon from '../../../../../../../assetss/img/filterIcon.svg'
import './index.scss'

const formatTime = seconds => {
  return [Math.floor(seconds / 60), Math.floor(seconds % 60)]
    .map(x => x.toString())
    .map(x => (x.length === 1 ? `0${x}` : x))
    .join(':')
}

const formatPercents = ( num, sum ) => {
  if(sum === 0 || num === 0) return '0%'
  return ((num / sum) * 100).toFixed() + '%'
}

const tableItem = ['Title', 'Time', 'Plays', 'Hashtags', 'Wow', 'Happy', 'Normal', 'Sad', 'Terrible', 'Upload date', 'Action']

const copySrc = src => navigator.clipboard.writeText(src)

const TablePodcast = ({ podcastLict, setOpenDelete, updatePodcast }) => {
  return (
    <Grid className='tablePodcast'>
      <Grid className='headerPodcast'>
        {tableItem?.map(i => (
          <Grid key={i} className={`podcast podcast${i}`}>
            {i} <img className='filterIcon' src={filterIcon} />
          </Grid>
        ))}
      </Grid>
      {podcastLict?.map(({ duration, feedback_1, feedback_2, feedback_3, feedback_4, feedback_5, feedback_total, listenCountByNotLoggedIn, listenCountByLoggedIn, createdAt, title, hashtags, podcast, uuid, image }, index) => (
        <Grid className='bodyPodcast' key={index}>
          <Grid className='podcastTitle podcastTitleBody'>
            {title}
          </Grid>
          <Grid className='podcastTime'>
            {formatTime(duration)}
          </Grid>
          <Grid className='podcastPlays'>
            <span className='podcastPlaysBodyHeader'>
              Login
            </span>
            <span className='podcastPlaysBody'>
              {listenCountByLoggedIn}
            </span>
            <span className='podcastPlaysBodyHeader'>
              No login
            </span>
            <span className='podcastPlaysBody'>
             {listenCountByNotLoggedIn}
            </span>
          </Grid>
          <Grid className='podcastHashtags podcastHashtagsBody'>
            #{hashtags?.map(i => i)}
          </Grid>
          <Grid className='podcastReaction'>
            {formatPercents(feedback_1, feedback_total)}
          </Grid>
          <Grid className='podcastReaction'>
            {formatPercents(feedback_2, feedback_total)}
          </Grid>
         <Grid className='podcastReaction'>
            {formatPercents(feedback_3, feedback_total)}
          </Grid>
          <Grid className='podcastReaction'>
            {formatPercents(feedback_4, feedback_total)}
          </Grid>
           <Grid className='podcastReaction'>
            {formatPercents(feedback_5, feedback_total)}
          </Grid>
          <Grid className='podcastUpload'>
            {moment(createdAt)?.format('MMM, D')}
          </Grid>
          <Grid className='podcastAction podcastActionBody'>
            <a className='linkTable' onClick={() => copySrc(`https://test.tellme.place/podcast/${uuid}`)}>Link</a>
            <Button className='btnDelete' variant='contained' onClick={() => setOpenDelete(uuid)}>DELETE</Button>
            <Button
              className='btnCansel' 
              variant='contained' 
              onClick={() => {
                updatePodcast({ title, hashtags, podcast, uuid, image })
              }}
            >
                EDIT
            </Button>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default TablePodcast
